import { NgModule } from '@angular/core';
import { DynamicPipe } from './dynamic.pipe';
import { CurrencyPipe, DatePipe } from '@angular/common';

@NgModule({
    imports: [
    ],
    declarations: [
        DynamicPipe
    ],
    exports: [
        DynamicPipe
    ],
    providers: [
        // CurrencyPipe,
        // DatePipe
    ]
})

export class DynamicPipeModule { }
